import React, { useState, useEffect } from 'react';
import { useInView } from '../useInView';

const REVIEWS = [
  {
    init: 'SK',
    meta: 'Local Guide • 9 reviews • 11 photos',
    time: 'Edited a year ago',
    grad: 'linear-gradient(135deg,#c8893a,#e8a84a)',
    text: 'Best quality,best price, speed delivery, full satisfied their work',
    stars: 5,
  },
  {
    init: 'TV',
    meta: '3 reviews',
    time: 'a month ago',
    grad: 'linear-gradient(135deg,#2e7d52,#43a572)',
    text: 'I had a very good experience with Laxmi Printers. They print carry bags with excellent design quality at reasonable prices, and the quality remains consistent even for large quantities. The shop is conveniently located at the entrance of Begum Bazar, making it easy for anyone to reach. I really appreciate the way they communicate with customers. Definitely a reliable printing shop.',
    stars: 5,
  },
  {
    init: 'MK',
    meta: '1 review',
    time: '2 years ago',
    grad: 'linear-gradient(135deg,#8b2fc9,#a855f7)',
    text: 'Best printing quality flexo (Digital) single colour printed covers within 1000pcs Others printers are saying minimum 4000pcs but they printed 1000pcs',
    stars: 5,
  },
  {
    init: 'MA',
    meta: '9 reviews',
    time: '3 years ago',
    grad: 'linear-gradient(135deg,#c0392b,#e74c3c)',
    text: 'Friendly dealing',
    stars: 5,
  },
  {
    init: 'RA',
    meta: '1 review',
    time: '2 years ago',
    grad: 'linear-gradient(135deg,#1f6feb,#3b82f6)',
    text: 'Best in service',
    stars: 5,
  },
  {
    init: 'MS',
    meta: '1 review',
    time: '2 years ago',
    grad: 'linear-gradient(135deg,#b45309,#f59e0b)',
    text: 'Best in service',
    stars: 5,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const [ref, v] = useInView();

  useEffect(() => {
    const t = setInterval(() => setActive(a => (a + 1) % REVIEWS.length), 4500);
    return () => clearInterval(t);
  }, []);

  const r = REVIEWS[active];

  return (
    <>
      <style>{`
        @keyframes testFade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        .test-dot:hover { background:rgba(200,137,58,0.5)!important; }
        @media(max-width:768px){
          .test-layout { grid-template-columns: 1fr !important; gap: 16px !important; }
          .test-quote-box { padding: 32px 24px !important; }
          .test-quote-text { font-size: 18px !important; line-height: 1.6 !important; }
          .test-quote-icon { font-size: 80px !important; top: 16px !important; left: 20px !important; }
          .test-stars { top: 16px !important; right: 20px !important; font-size: 14px !important; }
          .test-quote-meta { flex-direction: column !important; align-items: flex-start !important; gap: 8px !important; }
        }
        @media(max-width:480px){
          .test-quote-box { padding: 24px 16px !important; }
          .test-quote-text { font-size: 16px !important; }
          .test-quote-icon { font-size: 60px !important; top: 12px !important; left: 16px !important; }
          .test-stars { top: 12px !important; right: 16px !important; font-size: 12px !important; }
        }
      `}</style>
      <section style={s.section}>
        <div style={s.bgShape} />
        <div style={s.container}>
          <div ref={ref} style={{ opacity: v ? 1 : 0, transform: v ? 'none' : 'translateY(24px)', transition: 'all 0.7s ease' }}>
            <div style={s.tagLine}><span style={s.dash} /><span style={s.tag}>CLIENT REVIEWS</span><span style={s.dash} /></div>
            <h2 style={s.title}>What Our Clients<br /><em style={s.titleItalic}>Say About Us</em></h2>
          </div>

          <div className="test-layout" style={s.layout}>
            {/* Main quote */}
            <div className="test-quote-box" style={s.quoteBox} key={active}>
              <div className="test-quote-icon" style={s.quoteIcon}>"</div>
              <p className="test-quote-text" style={s.quoteText}>{r.text}</p>
              <div className="test-quote-meta" style={s.quoteMeta}>
                <div style={{ ...s.qAvatar, background: r.grad }}>{r.init}</div>
                <div>
                  <div style={s.qMetaTop}>{r.meta}</div>
                  <div style={s.qMetaTime}>{r.time}</div>
                </div>
              </div>
              <div className="test-stars" style={s.stars}>{'★'.repeat(r.stars)}</div>
            </div>
          </div>

          {/* Dots */}
          <div style={s.dots}>
            {REVIEWS.map((_, i) => (
              <button
                key={i}
                className="test-dot"
                style={{
                  ...s.dot,
                  background: active === i ? '#c8893a' : 'rgba(255,255,255,0.15)',
                  width: active === i ? 24 : 8,
                }}
                onClick={() => setActive(i)}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

const s = {
  section: {
    background: '#0a0a0a', padding: '120px 24px', position: 'relative', overflow: 'hidden',
    borderTop: '1px solid rgba(200,137,58,0.1)',
  },
  bgShape: {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%,-50%)', width: 800, height: 800, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(200,137,58,0.05) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  container: { maxWidth: 1280, margin: '0 auto' },
  tagLine: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, marginBottom: 14 },
  dash: { width: 40, height: 1, background: 'rgba(200,137,58,0.5)', display: 'inline-block' },
  tag: { fontSize: 11, letterSpacing: 4, color: '#c8893a', fontWeight: 700 },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(30px,4vw,52px)', fontWeight: 700,
    color: '#f0ede6', lineHeight: 1.15, marginBottom: 56, textAlign: 'center',
  },
  titleItalic: { fontStyle: 'italic', color: '#c8893a' },
  layout: { display: 'grid', gridTemplateColumns: '1fr', gap: 24, marginBottom: 32 },
  quoteBox: {
    background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(200,137,58,0.15)',
    borderRadius: 24, padding: '44px 48px', position: 'relative',
    animation: 'testFade 0.5s ease',
  },
  quoteIcon: {
    fontFamily: "'Cormorant Garamond',serif", fontSize: 120,
    color: 'rgba(200,137,58,0.12)', lineHeight: 0.8,
    position: 'absolute', top: 24, left: 32,
  },
  quoteText: {
    fontFamily: "'Cormorant Garamond',serif", fontSize: 22,
    color: 'rgba(240,237,230,0.85)', lineHeight: 1.7, fontStyle: 'italic',
    marginBottom: 32, position: 'relative', zIndex: 1,
  },
  quoteMeta: { display: 'flex', alignItems: 'center', gap: 14 },
  qAvatar: {
    width: 48, height: 48, borderRadius: '50%', flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 16, color: '#fff',
  },
  qMetaTop: { fontSize: 13, fontWeight: 700, color: '#f0ede6' },
  qMetaTime: { fontSize: 12, color: 'rgba(240,237,230,0.45)', marginTop: 2 },
  stars: { position: 'absolute', top: 24, right: 32, fontSize: 16, color: '#c8893a', letterSpacing: 2 },
  dots: { display: 'flex', justifyContent: 'center', gap: 8 },
  dot: {
    height: 8, borderRadius: 4, border: 'none', cursor: 'pointer',
    transition: 'all 0.3s ease', padding: 0,
  },
};
